/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type PortalRefreshBusServicingPeriodMutationVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  reportingPeriod: Types.Scalars['FullDateStr'];
}>;


export type PortalRefreshBusServicingPeriodMutationGQLType = (
  { __typename?: 'Mutation' }
  & Pick<Types.MutationGQLType, 'portalRefreshBusServicingPeriod'>
);


export const PortalRefreshBusServicingPeriodDocumentGQLType = gql`
    mutation PortalRefreshBusServicingPeriod($implementationId: UUID!, $reportingPeriod: FullDateStr!) {
  portalRefreshBusServicingPeriod(
    implementationId: $implementationId
    reportingPeriod: $reportingPeriod
  )
}
    `;
export type PortalRefreshBusServicingPeriodMutationFnGQLType = Apollo.MutationFunction<PortalRefreshBusServicingPeriodMutationGQLType, PortalRefreshBusServicingPeriodMutationVariablesGQLType>;

/**
 * __usePortalRefreshBusServicingPeriodMutation__
 *
 * To run a mutation, you first call `usePortalRefreshBusServicingPeriodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePortalRefreshBusServicingPeriodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [portalRefreshBusServicingPeriodMutation, { data, loading, error }] = usePortalRefreshBusServicingPeriodMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      reportingPeriod: // value for 'reportingPeriod'
 *   },
 * });
 */
export function usePortalRefreshBusServicingPeriodMutation(baseOptions?: Apollo.MutationHookOptions<PortalRefreshBusServicingPeriodMutationGQLType, PortalRefreshBusServicingPeriodMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PortalRefreshBusServicingPeriodMutationGQLType, PortalRefreshBusServicingPeriodMutationVariablesGQLType>(PortalRefreshBusServicingPeriodDocumentGQLType, options);
      }
export type PortalRefreshBusServicingPeriodMutationHookResult = ReturnType<typeof usePortalRefreshBusServicingPeriodMutation>;
export type PortalRefreshBusServicingPeriodMutationResultGQLType = Apollo.MutationResult<PortalRefreshBusServicingPeriodMutationGQLType>;
export type PortalRefreshBusServicingPeriodMutationOptionsGQLType = Apollo.BaseMutationOptions<PortalRefreshBusServicingPeriodMutationGQLType, PortalRefreshBusServicingPeriodMutationVariablesGQLType>;